import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CreateDefectRequest,
  Defect,
  DefectListFilters,
  DefectListItem,
  UpdateDefectRequest,
} from '../models/defect.model';
import { Page } from '../models/page.model';

@Injectable({ providedIn: 'root' })
export class DefectService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  private defectsUrl(projectId: string): string {
    return `${this.base}/${projectId}/defects`;
  }

  create(projectId: string, stepResultId: string, req: CreateDefectRequest): Observable<Defect> {
    return this.http.post<Defect>(`${this.base}/${projectId}/test-runs/step-results/${stepResultId}/defects`, req);
  }

  get(projectId: string, defectId: string): Observable<Defect> {
    return this.http.get<Defect>(`${this.defectsUrl(projectId)}/${defectId}`);
  }

  list(projectId: string, filters: DefectListFilters): Observable<Page<DefectListItem>> {
    let params = new HttpParams().set('page', String(filters.page)).set('size', String(filters.size));
    for (const status of filters.status ?? []) {
      params = params.append('status', status);
    }
    if (filters.releaseId) params = params.set('releaseId', filters.releaseId);
    if (filters.assigneeUserId) params = params.set('assigneeUserId', filters.assigneeUserId);
    return this.http.get<Page<DefectListItem>>(this.defectsUrl(projectId), { params });
  }

  update(projectId: string, defectId: string, req: UpdateDefectRequest): Observable<Defect> {
    return this.http.patch<Defect>(`${this.defectsUrl(projectId)}/${defectId}`, req);
  }
}
